export const appURL = `${process.env.REACT_APP_URL}/`;
const baseURL = `${appURL}api/`;

interface IResponse<T> {
    success: boolean;
    data: T;
    message: string;
    code?: number;
}

export const RestApi = <T>(method: string, url: string, data: Object, authToken?: string) => {
    return new Promise<T>((resolve, reject) => {
        const options: object = {
            method,
            body: JSON.stringify(data),
            headers: {
                'token': '1@3Hg#hH6$8A4%R^3g&vb*v(',
                'content-type': 'application/json',
                ...(authToken ? { 'auth': `Bearer ${authToken}` } : {}),
            }
        };
        fetch(`${baseURL}${url}`, options).then(function (response) {
            if (!response.ok) {
                throw new Error('Sorry, something went wrong with the network, Please try after sometime');
            }
            return response.json();
        }).then(function (response: IResponse<T>) {
            if (response.success) {
                return resolve(response.data);
            } else {
                // if (response?.code && [10002, 10003, 10004].includes(response.code)) {
                //     window.location.href = '/auth/logout';
                // }
                return reject(response.message);
            }
        }).catch(function (error) {
            let message = typeof error.response !== "undefined" ? error.response.message : error.message;
            return reject(message);
        });
    });
}